import { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Pagination,
  Stack,
  TextField,
  InputLabel,
  IconButton,
  Button,
} from "@mui/material";
import Colors from "../../assets/styles";
import AuthServices from "../../apis/AuthServices";
import moment from "moment";
import SimpleDialog from "../../components/Modal";
import DeleteIcon from "@mui/icons-material/Delete";
import { ErrorToaster, SuccessToaster } from "../../components/toaster";


export default function AllocationList() {
  const [page, setPage] = useState(1);  
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState([]);
  const [filteredLocomotives, setFilteredLocomotives] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [count, setCount] = useState(0);
  const [offset, setOffset] = useState(0); 
  const [limit, setLimit] = useState(10);  
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState("");

  
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    setOffset((newPage - 1) * rowsPerPage);  
    getNotificationList((newPage - 1) * rowsPerPage, rowsPerPage);  
  };

  const getNotificationList = async (offset = 0, limit = 10) => {
    try {
      const result = await AuthServices.getNotification(offset, limit);
      if (result.IsSuccess) {
        setNotification(result?.Response?.data);
        setFilteredLocomotives(result.Response.data);
        setCount(result?.Response?.TotalCount);
      }
    } catch (error) {
      console.error("Error fetching allocation list:", error);
    }
  };

  useEffect(() => {
    getNotificationList(offset, limit);
  }, [offset, limit]);

  const deleteNotification = async () => {
    
    try {
      const result = await AuthServices.deleteNotification(selectedNotification?.NotificationID ,1);
      
      if (result.IsSuccess == true) {
        SuccessToaster("Deleted Successfully");
        getNotificationList();
        setDeleteDialog(false)
      }
    } catch (error) {
      ErrorToaster("Something went Wrong");
    }
  };
  
  return (
    <>
      <SimpleDialog
        open={deleteDialog}
        onClose={() => {
          setDeleteDialog(false);
        }}
       >
     <Typography variant="h6" sx={{ mb: 2 ,textAlign:"center" }}>
          Are you sure you want to Delete this Notification?
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-around', gap: 2,mt:3 }}>
          <Button sx={{background:"grey",color:"white",px:2.5}} onClick={()=> setDeleteDialog(false)}>
            Cancel
          </Button>
          <Button variant="contained" sx={{background:"rgb(0, 100, 0)"}} onClick={deleteNotification} >
            Confirm
          </Button>
        </Box>
      </SimpleDialog>
      <Box sx={{ mb: 3  ,display:'flex' ,justifyContent:'space-between',alignItems:'center'}}>
        <Typography
          variant="h5"
          component="h1"
          sx={{
            color: Colors.primary,
            fontWeight: 500,
            letterSpacing: "1px",
            textTransform:"uppercase"
          }}
        >
        Notification List
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{textTransform:"uppercase"}}>
        Notification / Notification List
        </Typography>
      </Box>

      <Container
        maxWidth="xl"
        sx={{
          mt: 2,
          boxShadow: "0px 8px 24px 0 #4545501A",
          py: 2,
          backgroundColor: Colors.white,
          borderRadius:"12px"
        }}
      >
       
        <TableContainer sx={{ height: "auto", overflowX: "auto" }}>
           
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: "rgb(19 62 2)" }}>
                <TableCell sx={{ color: "white", width: "5%" }}>#</TableCell>
                <TableCell sx={{ color: "white", width: "25%" }}>Title</TableCell>
                <TableCell sx={{ color: "white", width: "20%" }}>Description</TableCell>
                <TableCell sx={{ color: "white", width: "20%" }}>CreatedDate</TableCell>
                <TableCell sx={{ color: "white", width: "20%" }}>UserName</TableCell>
                <TableCell sx={{ color: "white", width: "20%" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : (
                notification.map((noti, index) => (
                    <TableRow key={noti.LocomotiveId}>
                      <TableCell>{index + 1 + (page - 1) * rowsPerPage}</TableCell>
                      <TableCell>{noti?.Title}</TableCell>
                      <TableCell>{noti?.Description}</TableCell>
                      <TableCell>{moment(noti?.CreatedDate).format("DD MMMM YYYY")}</TableCell>
                      <TableCell>{noti?.UserName || "-"}</TableCell>
                      <TableCell>
                       
                        <IconButton
                          aria-label="delete"
                          onClick={() => {
                            setDeleteDialog(true);
                            setSelectedNotification(noti);
                          }}
                        
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                     
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Stack direction="row" justifyContent="center" alignItems="center" sx={{ mt: 2 }}>
          <Pagination
            count={Math.ceil(count / rowsPerPage)} 
            page={page}
            onChange={handlePageChange}
            variant="outlined"
            shape="rounded"
            color="success"
            sx={{
              "& .MuiPaginationItem-root": {
                borderColor: "rgb(19, 62, 2)",
                color: "rgb(19, 62, 2)",
              },
              "& .MuiPaginationItem-page.Mui-selected": {
                bgcolor: "rgb(19, 62, 2)",
                color: "white",
              },
            }}
          />
        </Stack>
      </Container>
    </>
  );
}
